import React from 'react';
import './FooterSocket.css';

function FooterSocket() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="footer-socket">
      <div className="container">
        <div className="footer-socket-content">
          <p className="footer-socket-copyright">
            &copy; {currentYear} STOREZI. All rights reserved.
          </p>
          <div className="footer-socket-links">
            <a 
              href="#terms" 
              className="footer-socket-link"
              style={{ textDecoration: 'none', borderBottom: 'none' }}
            >
              Terms & Conditions
            </a>
            <a 
              href="#privacy" 
              className="footer-socket-link"
              style={{ textDecoration: 'none', borderBottom: 'none' }}
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FooterSocket;
